import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 系统配置相关服务
 */
export class SysConfigServiceSvr {
    constructor() {
        this.baseurl = 'SysConfigServiceSvr.assx/';
    }

    /**
     * 获取当前用户菜单
     * token:String
     */
    getUserMenus(token){
        return request.post(this.baseurl + 'getUserMenus', Qs.stringify({ token:token }));
    }

    /**
     * 根据用户角色 获取信息公开发布菜单
     * token:String
     */
    getPublicInfoMenuByToken(token){
        return request.post(this.baseurl + 'getPublicInfoMenuByToken', Qs.stringify({ token:token }));
    }

    /**
     * 获取系统相关配置
     * keyName:String
     */
    getSystemConfig(keyName){
        return request.post(this.baseurl + 'getSystemConfig', Qs.stringify({ keyName:keyName }));
    }
}